module.exports = __webpack_public_path__ + "static/media/sagar-theme.eb122166.wav";